import { Consumer } from '@layouts/LearningPath/Context'
import ProgressionNav from '@layouts/LearningPath/ProgressNavs'
import { ProgressionNavProp } from '@layouts/LearningPath/ProgressNavs/interface'
import React from 'react'
import { Col } from 'react-styled-flexboxgrid'

const ProgressNav: React.FC<ProgressionNavProp> = ({ Units, scrollerId }) => (
  <>
    <Consumer>
      {({ active, activeHover, setActive }) => {
        return (
          <>
            <Col xs={12} lg={false} className="no-padding">
              <ProgressionNav
                active={active}
                activeHover={activeHover}
                setActive={setActive}
                Units={Units}
                pageSize={5}
                scrollerId={scrollerId}
              />
            </Col>
            <Col xs={false} lg={12} className="no-padding">
              <ProgressionNav
                active={active}
                activeHover={activeHover}
                setActive={setActive}
                Units={Units}
                pageSize={12}
                scrollerId={scrollerId}
              />
            </Col>
          </>
        )
      }}
    </Consumer>
  </>
)

export default ProgressNav
